import { useEffect } from "react";

import { createCookie, readCookie } from "../utils/functions";
import { isMobile } from "../utils/mobileDetection";

/**
 * Custom hook for handling UTM parameters
 * Extracts UTM data from URL search params and creates a cookie
 * Extracts Coupon code from url search params and creates a cookie
 */

export const useUtm = () => {
	useEffect(() => {
		try {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const couponName = urlSearchParams.get("coupon");

			const utmParams = {
				utm_source: urlSearchParams.get("utm_source"),
				utm_pathname: urlSearchParams.get("utm_pathname"),
				utm_referrer: urlSearchParams.get("utm_referrer"),
				utm_medium: urlSearchParams.get("utm_medium"),
				utm_campaign: urlSearchParams.get("utm_campaign"),
				utm_content: urlSearchParams.get("utm_content"),
				utm_term: urlSearchParams.get("utm_term"),
			};

			const utmData = Object.fromEntries(
				Object.entries(utmParams).filter(([, value]) => value != null)
			);

			let existingCookie = {};

			try {
				const rawCookie = readCookie("UTM");

				if (rawCookie) {
					let parsedValue;

					try {
						parsedValue = JSON.parse(rawCookie);
					} catch {
						try {
							const decoded = decodeURIComponent(rawCookie);
							parsedValue = JSON.parse(decoded);
						} catch (err) {
							console.error("UTM cookie invalid format:", err);
							parsedValue = {};
						}
					}

					existingCookie = parsedValue || {};
				}
			} catch (err) {
				console.error("UTM cookie corrupted:", err);
				existingCookie = {};
			}

			let mobileStatus = false;
			try {
				mobileStatus = isMobile();
			} catch (err) {
				console.error("isMobile failed:", err);
			}

			const updatedCookie = {
				...existingCookie,
				...(Object.keys(utmData).length > 0 ? utmData : {}),
				isOnMobile: mobileStatus,
			};

			try {
				createCookie(
					"UTM",
					JSON.stringify(updatedCookie),
					true,
					30 * 24 * 60 * 60 * 1000,
					"/",
					true,
					true
				);
			} catch (err) {
				console.error("Failed to set UTM cookie:", err);
			}

			if (couponName) {
				try {
					createCookie(
						"coupon_name",
						couponName,
						true,
						1 * 60 * 60 * 1000,
						"/",
						false,
						true
					);
				} catch (err) {
					console.error("Failed to set coupon cookie:", err);
				}
			}
		} catch (error) {
			console.error("useUtm crashed completely:", error);
		}
	}, []);

	return null;
};
